import styles from "./UserChatMessage.module.css";
import userImg from "../../assets/img/user.png";
interface Props {
    message: string;
}

export const UserChatMessage = ({ message }: Props) => {
    return (
        <div className={styles.container}>
            <img src={userImg} alt="logo-user" />
            <div className={styles.message}>{message}</div>
        </div>
    );
};
